import { hotjar } from 'react-hotjar'

const hostname = window && window.location && window.location.hostname

if (hostname === 'app.bed-booking.com' || hostname === 'react.bed-booking.com' || hostname === 'pwa.bed-booking.com' ) {
  hotjar.initialize(3198377, 6)
} else {
  hotjar.initialize(3229071, 6)
}

const actions = {
  identify: userId => {
    hotjar.identify('USER_ID', { userProperty: userId })
  },
}

export const Hotjar = actions
